export default __webpack_public_path__ + "static/media/OSMOS_NEBBIA-RIBBED_60X120_modulo_ribbed.63ca9612.jpg";